import { ApplePayCardTypes, CardTypes } from 'state/payment/types';

/**
 * This object maps the apple pay card types (frontend/ios/App/App/ApplePayPlugin.swift) with our CardTypes
 */
type IMapApplePayCardTypes = {
  [key in ApplePayCardTypes]: CardTypes;
};

const applePayCardTypeMap: IMapApplePayCardTypes = {
  AmEx: CardTypes.AMEX,
  Discover: CardTypes.DISCOVER,
  MasterCard: CardTypes.MASTERCARD,
  Visa: CardTypes.VISA,
};

/** This function takes an optional string coming from the apple pay payload and try to map this string with our CardType enum */
export const mapApplePayCardType = (applePayCardType?: string) => {
  return applePayCardType && applePayCardTypeMap[applePayCardType];
};
